var engravingSelector = document.querySelector('[data-js-engraving="engraving-selector"]');

if (engravingSelector) {
  // --- Engraving price adjustment start ---
  var ENGRAVING_PRICE_DOLLARS = parseInt(engravingSelector.getAttribute("data-js-engraving-price-dollars"), 10);
  // --- Engraving price adjustment end ---
  var isError = false;
  var engravingContainer = engravingSelector.querySelector('[data-js-engraving="container"]');
  var engravingHeader = engravingSelector.querySelector(".engraving-selector__header");
  var engravingInputs = engravingSelector.querySelectorAll('[data-js-engraving="engraving-input"]');
  var mobileErrorMessage = engravingSelector.querySelector('[data-js-engraving="error-mobile"]');
  var desktopErrorMessage = engravingSelector.querySelector('[data-js-engraving="error-desktop"]');
  var fieldErrorMessages = engravingSelector.querySelectorAll('[data-js-engraving="field-error"]');
  var addToCartButton = document.querySelector('[data-js="add-to-cart"]');
  var addButton = engravingSelector.querySelector('[data-js-engraving="add"]');
  var removeButton = engravingSelector.querySelector('[data-js-engraving="remove"]');
  var engravingMax = parseInt(engravingSelector.getAttribute("data-js-engraving-max")) || 30;
  var engravingType = engravingSelector.getAttribute("data-js-engraving-type");
  var mobileViewport = window.matchMedia("(max-width: 767.98px)");
  var errorState = {
    kind: "none",
    text: "",
    exceededFields: [],
  };
  var graphemeSegmenter =
    typeof Intl !== "undefined" && typeof Intl.Segmenter === "function"
      ? new Intl.Segmenter(undefined, { granularity: "grapheme" })
      : null;

  // --- Listeners ---
  addButton.addEventListener("click", initializeEngraving);
  removeButton.addEventListener("click", closeEngraving);

  engravingInputs.forEach(function (input) {
    input.addEventListener("input", onEngravingInputChange);
  });

  engravingHeader.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") {
      // Keyboard accessibility: activating engraving must not submit the product form.
      e.preventDefault();
      e.stopPropagation();

      if (!engravingSelector.classList.contains("opened")) {
        initializeEngraving();
      } else {
        closeEngraving();
      }
    }
  });

  if (typeof mobileViewport.addEventListener === "function") {
    mobileViewport.addEventListener("change", renderErrorState);
  } else if (typeof mobileViewport.addListener === "function") {
    mobileViewport.addListener(renderErrorState);
  }

  // --- Helper: simulate clicking on label if swatch exists ---
  function triggerSwatchClick(value) {
    var swatchContainer = document.querySelector('[data-name="engraving"]');
    if (!swatchContainer) return;

    var label = swatchContainer.querySelector(`label[for="radio-engraving-${value}"]`);
    if (label) label.click();
  }

  function getActiveErrorMessageElement() {
    return mobileViewport.matches ? mobileErrorMessage : desktopErrorMessage;
  }

  function getFieldErrorMessage(index) {
    return engravingSelector.querySelector(`[data-js-engraving="field-error"][data-index="${index}"]`);
  }

  function setErrorMessageState(element, text, isVisible) {
    if (!element) return;

    element.style.display = isVisible ? "block" : "none";
    element.innerHTML = isVisible ? text : "";
  }

  function hideGeneralErrorMessages() {
    setErrorMessageState(mobileErrorMessage, "", false);
    setErrorMessageState(desktopErrorMessage, "", false);
  }

  // --- Engraving price adjustment start ---
  function getPriceDollars(priceElement) {
    var text = priceElement ? priceElement.textContent : "";
    var normalizedText = text.replace(/[^0-9.,]/g, "").replace(/,/g, "");
    var amount = parseInt(normalizedText, 10);

    return isNaN(amount) ? null : amount;
  }

  function getBasePriceDollars(priceElement) {
    if (!priceElement) return null;

    var storedBasePrice = parseInt(priceElement.getAttribute("data-base-price-dollars"), 10);
    if (!isNaN(storedBasePrice)) return storedBasePrice;

    var parsedBasePrice = getPriceDollars(priceElement);
    if (parsedBasePrice !== null) {
      priceElement.setAttribute("data-base-price-dollars", parsedBasePrice);
    }

    return parsedBasePrice;
  }

  function getFilledEngravingCount() {
    var filledCount = 0;

    engravingInputs.forEach(function (input) {
      if (input.value.trim() !== "") filledCount++;
    });

    return filledCount;
  }

  function formatPrice(dollars) {
    var wholeDollars = Math.round(dollars);

    return "$" + wholeDollars.toLocaleString("en-US");
  }

  function setVisiblePrice(priceElement, priceText) {
    var didUpdateTextNode = false;

    Array.prototype.forEach.call(priceElement.childNodes, function (node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== "") {
        if (!didUpdateTextNode) {
          node.textContent = priceText;
          didUpdateTextNode = true;
        } else {
          node.textContent = "";
        }
      }
    });

    if (didUpdateTextNode) return;

    priceElement.insertBefore(document.createTextNode(priceText), priceElement.firstChild);
  }

  function updateEngravingProductPrice() {
    var priceElement = document.getElementById("ProductPrice");
    var basePriceDollars = getBasePriceDollars(priceElement);

    if (basePriceDollars === null) return;

    setVisiblePrice(
      priceElement,
      formatPrice(basePriceDollars + getFilledEngravingCount() * ENGRAVING_PRICE_DOLLARS)
    );
  }
  // --- Engraving price adjustment end ---

  function hideFieldErrorMessages() {
    fieldErrorMessages.forEach(function (errorMessage) {
      setErrorMessageState(errorMessage, "", false);
    });
  }

  function buildLengthErrorMessage(exceededFields) {
    var labels = exceededFields.map(function (field) {
      return field.label;
    });

    return `Please ensure the following engravings do not exceed the maximum length: ${labels.join(", ")}. 
      If you need more characters, please <a href='mailto:care@automicgold.com'>email us</a> for assistance.`;
  }

  function buildFieldLengthErrorMessage(field) {
    var characterLabel = field.maxLength === 1 ? "character" : "characters";

    return `Please ensure ${field.label} does not exceed ${field.maxLength} ${characterLabel}. If you need more characters, please <a href='mailto:care@automicgold.com'>email us</a> for assistance.`;
  }

  function renderErrorState() {
    hideGeneralErrorMessages();
    hideFieldErrorMessages();

    if (errorState.kind === "general") {
      setErrorMessageState(getActiveErrorMessageElement(), errorState.text, true);
    }

    if (errorState.kind === "length") {
      if (mobileViewport.matches) {
        errorState.exceededFields.forEach(function (field) {
          setErrorMessageState(getFieldErrorMessage(field.index), buildFieldLengthErrorMessage(field), true);
        });
      } else {
        setErrorMessageState(desktopErrorMessage, buildLengthErrorMessage(errorState.exceededFields), true);
      }
    }

    if (addToCartButton) {
      addToCartButton.classList.toggle("btn--disabled", errorState.kind !== "none");
    }
  }

  function setGeneralErrorState(text) {
    errorState = {
      kind: "general",
      text: text,
      exceededFields: [],
    };
    renderErrorState();
  }

  function setLengthErrorState(exceededFields) {
    errorState = {
      kind: "length",
      text: "",
      exceededFields: exceededFields,
    };
    renderErrorState();
  }

  function clearErrorState() {
    errorState = {
      kind: "none",
      text: "",
      exceededFields: [],
    };
    renderErrorState();
  }

  // --- Open engraving ---
  function initializeEngraving() {
    engravingSelector.classList.add("opened");

    // Keyboard accessibility: expose links and controls only while engraving is open.
    engravingContainer.removeAttribute("inert");
    engravingHeader.setAttribute("aria-expanded", "true");

    engravingInputs.forEach(function (input) {
      input.setAttribute("tabindex", "0");
    });

    if (engravingInputs[0]) engravingInputs[0].focus();

    // Only if swatch engraving exists - simulate click "Engraved"
    if (document.querySelector('[data-name="engraving"]')) {
      triggerSwatchClick("no-engraving");
    }

    // Add hidden notice
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && !form.querySelector('[name="properties[Notice]"]')) {
      var hiddenInput = document.createElement("input");
      hiddenInput.type = "hidden";
      hiddenInput.name = "properties[Notice]";
      hiddenInput.value = "All engraved items are final sale.";
      form.appendChild(hiddenInput);
    }

    setGeneralErrorState("Engraving can't be empty.");
    // --- Engraving price adjustment start ---
    updateEngravingProductPrice();
    // --- Engraving price adjustment end ---

    if (typeof ga === "function") {
      ga("send", "event", "Engraving Selector", "Opened");
    }
  }

  // --- Close engraving ---
  function closeEngraving() {
    engravingSelector.classList.remove("opened");

    // Keyboard accessibility: keep all closed engraving content out of Tab navigation.
    engravingContainer.setAttribute("inert", "");
    engravingHeader.setAttribute("aria-expanded", "false");

    engravingInputs.forEach(function (input) {
      input.value = "";
      input.setAttribute("tabindex", "-1");
    });

    clearErrorState();
    isError = false;
    // --- Engraving price adjustment start ---
    updateEngravingProductPrice();
    // --- Engraving price adjustment end ---

    // Only if swatch engraving exists - simulate "No engraving" click
    if (document.querySelector('[data-name="engraving"]')) {
      triggerSwatchClick("no-engraving");
    }

    // Remove the hidden notice
    var existingNotice = document.querySelector('[name="properties[Notice]"]');
    if (existingNotice) existingNotice.remove();

    // Hide the preview
    document.querySelectorAll(".product-engraving-preview").forEach(function (preview) {
      preview.style.display = "none";
    });

    if (typeof ga === "function") {
      ga("send", "event", "Engraving Selector", "Closed");
    }
  }

  function getCharacterCount(value) {
    if (!value) return 0;

    if (graphemeSegmenter) {
      return Array.from(graphemeSegmenter.segment(value)).length;
    }

    return Array.from(value).length;
  }

  // --- Check engraving ---
  function onEngravingInputChange(e) {
    var inputText = e.target.value;
    var allInputsEmpty = true;
    var exceededFields = [];

    // --- Engraving price adjustment start ---
    updateEngravingProductPrice();
    // --- Engraving price adjustment end ---

    engravingInputs.forEach(function (input) {
      if (input.value.trim() !== "") allInputsEmpty = false;

      var maxLength = parseInt(input.getAttribute("data-max")) || engravingMax;
      var label = input.getAttribute("data-label");

      if (getCharacterCount(input.value) > maxLength) {
        exceededFields.push({
          index: input.closest(".product-engraving-field").getAttribute("data-index"),
          label: label,
          maxLength: maxLength,
        });
        input.classList.add("error-max");
      } else {
        input.classList.remove("error-max");
      }

      // Preview
      var parent = input.closest(".product-engraving-field");
      if (parent) {
        var index = parent.getAttribute("data-index");
        var preview = document.getElementById(index);
        if (preview) {
          var previewText = preview.querySelector(".product-engraving-preview__preview-text");
          previewText.textContent = input.value;
          preview.style.display = input.value.trim() !== "" ? "block" : "none";
        }
      }
    });

    if (allInputsEmpty) {
      isError = true;
      setGeneralErrorState("Engraving can't be empty.");
      return;
    }

    if (exceededFields.length > 0) {
      isError = true;
      setLengthErrorState(exceededFields);

      if (typeof ga === "function") {
        var engravingTypeText =
          engravingType === "disk"
            ? "Engraving Selector"
            : `${engravingType.charAt(0).toUpperCase() + engravingType.slice(1)} Engraving Selector`;
        ga("send", "event", engravingTypeText, "Engraving too long");
      }

      return;
    }

    isError = false;
    clearErrorState();
  }

  // --- Engraving price adjustment start ---
  window.updateEngravingProductPrice = updateEngravingProductPrice;
  updateEngravingProductPrice();
  // --- Engraving price adjustment end ---
}
